import * as THREE from "three";
import temple from './Scenes assets/Fxscene3/Temple.glb'
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
let scene, camera

function fullscene(scene, camera) {
  this.scene = scene
  this.camera = camera
}

export default function Temple(renderer, loadingmanager) {


  function init() {
    
    scene = new THREE.Scene();
    const loader = new GLTFLoader(loadingmanager);
    const templeload = loader.loadAsync(temple).then((val) => {
      scene.add(val.scene)

    });
    const width = window.innerWidth,
      height = window.innerHeight;
    camera = new THREE.PerspectiveCamera(70, width / height, 0.01, 100);
    
    camera.position.z = 7;
    camera.position.y = 5
    camera.position.x = -9

    
    camera.rotation.y =  95


  }

  function animate() {
    requestAnimationFrame(animate);
  }




  init()
  animate()
  let block = new fullscene(scene, camera)
  return block
}